// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
const baseUrl = 'https://wxm9f8l0y7.execute-api.eu-central-1.amazonaws.com';

export const environment = {
  baseUrl: baseUrl,
  production: false,
  apiUrl: baseUrl + '/api',
  // apiUrl: 'http://localhost:3000/api',
  reportsApi: baseUrl + '/api/reports',
  accessApi: baseUrl + '/api/access',
  imageUrl: baseUrl + '/api/images/',
  featureFlags: {
    filterProjects: false,
    projectNotifications: false,
    dashboards: false,
    tasks: false,
    globalSearch: false,
  },
  googleClientId: '820904729293-761fs6e8q5s3ngglfnin5km852ugk01m.apps.googleusercontent.com',
  microsoftClientId: '174cba1f-c047-48e5-895b-2357fa8f6741',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
